import HttpClient from '@/resources/http/client';

function triggerLogin(url: string): void {
  window.location.replace(`/auth/authorize?state=${url}`);
}

export function unauthorizedInterceptor(response: Response): void {
  if (response.status === 401) {
    triggerLogin(window.location.pathname);
  }
}

export function revokeAuthentication() {
  return HttpClient.get<void>('/auth/logout').toPromise();
}
